export default __webpack_public_path__ + "static/media/EM0350.34I-22010_-14993_0.8ac1cebc.jpg";